import { DateTime } from 'luxon';

import { TIMEZONE_MAP } from 'config/timezones';

export const getLocationTimezone = (location) => (location && location.timeZone) || DateTime.local().zoneName;

export const getLocationTimezoneName = (location) => TIMEZONE_MAP[getLocationTimezone(location)] || '';
